import { render, staticRenderFns } from "./VueTextToSpeech.vue?vue&type=template&id=d35703ac&scoped=true&"
import script from "./VueTextToSpeech.vue?vue&type=script&lang=js&"
export * from "./VueTextToSpeech.vue?vue&type=script&lang=js&"
import style0 from "./VueTextToSpeech.vue?vue&type=style&index=0&id=d35703ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35703ac",
  null
  
)

export default component.exports